export let RecurrencePeriodTypes = /*#__PURE__*/function (RecurrencePeriodTypes) {
  RecurrencePeriodTypes["Weekly"] = "weekly";
  RecurrencePeriodTypes["BiWeekly"] = "biweekly";
  RecurrencePeriodTypes["Monthly"] = "monthly";
  RecurrencePeriodTypes["Quarterly"] = "quarterly";
  RecurrencePeriodTypes["Yearly"] = "yearly";
  return RecurrencePeriodTypes;
}({});